// Para birimi yardımcıları. API her fiyatı 3 para biriminde döndürür
// (priceEuro/priceTL/priceUsd ve ana sayfada minPriceEuro/minPriceTL/minPrice),
// bu yüzden dönüştürme yapmayız — sadece seçili para biriminin alanını seçeriz.

// NOT: Backend ödemeyi priceId'nin VERSİYONLU fiyatından hesaplıyor; EUR'da bu
// `versionedPriceEur` alanı (priceEuro değil!). Tahsil edilen tutarla ekranın
// eşleşmesi için EUR'da önce versionedPriceEur'u kullanırız (yoksa priceEuro).
export const CURRENCIES = [
  { code: 'EUR', symbol: '€', priceField: 'priceEuro', versionedField: 'versionedPriceEur', minField: 'minPriceEuro' },
  { code: 'TRY', symbol: '₺', priceField: 'priceTL', minField: 'minPriceTL' },
  { code: 'USD', symbol: '$', priceField: 'priceUsd', minField: 'minPrice' },
];

export const DEFAULT_CURRENCY = 'EUR';

export const getCurrencyMeta = (code) =>
  CURRENCIES.find((c) => c.code === code) || CURRENCIES[0];

// Sayısal değeri seçili para biriminin sembolüyle biçimler. (₺120 → ₺120,00)
export const formatPrice = (value, code) => {
  const n = parseFloat(value);
  if (value == null || Number.isNaN(n)) return null;
  const { symbol } = getCurrencyMeta(code);
  const formatted = n.toLocaleString('tr-TR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `${symbol}${formatted}`;
};

// Bir refill/obje üzerinden seçili para biriminin fiyatını alır.
// EUR'da versionedPriceEur (varsa) önceliklidir — tahsil edilen tutar budur.
export const pickPrice = (obj, code) => {
  const m = getCurrencyMeta(code);
  const versioned = m.versionedField ? obj?.[m.versionedField] : undefined;
  return versioned ?? obj?.[m.priceField];
};

// Bir ülkenin paketleri içindeki en düşük (pozitif) fiyatı seçili para biriminde.
export const minPriceOf = (products, code) => {
  let min = null;
  (products || []).forEach((p) =>
    (p.refills || []).forEach((r) => {
      const v = parseFloat(pickPrice(r, code));
      if (!Number.isNaN(v) && v > 0) min = min == null || v < min ? v : min;
    })
  );
  return min;
};
